<template>
  <div>
    <div class="flex items-center justify-end flex-wrap profile-header-nav py-5 mt-5">
      <div class="block w-full flex-grow sm:flex sm:items-center sm:w-auto">
        <div class="text-sm sm:flex-grow">
          <div
            class="custom-tab md:flex mt-8 w-full md:mt-0 md:ml-auto md:w-4/4 hidden"
            role="tablist"
            @keyup.right="navigate('right')"
            @keyup.left="navigate('left')"
          >
            <template v-for="(item, index) in tab_contents">
              <router-link
                class="tab-item"
                v-if="!item.hidden"
                :key="`tab_link_${index}`"
                :id="`tab-link-${index}`"
                role="tab"
                :to="item.link"
                :aria-selected="activeChildIndex === index ? 'true' : 'false'"
                :aria-controls="`tab-link-${index}`"
                :tabindex="tabIndex(index, item.name)"
              >
                {{ item.name }}
              </router-link>
            </template>
          </div>
          <select
            class="default-select tab-select block md:hidden"
            @change="onChange($event)"
            v-model="tab_value"
            aria-label="Select a section"
          >
            <template v-for="(item, ind) in tab_contents">
              <option v-if="!item.hidden" :key="`tab_link-opion-${ind}`" :value="item.link">
                {{ item.name }}
              </option>
            </template>
          </select>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-3/4">
        <transition name="zoom-fade" mode="out-in">
          <router-view @activityLoaded="updateActivity" />
        </transition>
      </div>
      <div class="vx-col w-full lg:w-1/4">
        <vx-card title="Virtual Job Experience" class="mt-base" v-if="experience.type === 1">
          <div class="user-bio mb-5">
            <heading size="h3" style-size="h5">{{ experience.vje.name }}</heading>
          </div>

          <div class="user-bio mb-5">
            <heading size="h3" style-size="h5" class="mb-3">Started:</heading>
            <p>{{ experience.date_started_formatted }}</p>
          </div>

          <div class="user-bio mb-5" v-if="experience.type === 1">
            <heading size="h3" style-size="h5" class="mb-3">Top 3 Work Related Skills:</heading>
            <ul class="default-list">
              <li v-for="(skill, index) in this.experience.vje.skills" :key="index">{{ skill }}</li>
            </ul>
          </div>
        </vx-card>
        <vx-card title='"Real World" Experience' class="mt-base" v-else>
          <p class="mb-5">"The only place where success comes before work is in the dictionary.”</p>

          <p>(Vince Lombardi)</p>
        </vx-card>

        <vx-card title="Submit This Experience" v-if="experience.active === 1">
          <p class="mb-5">
            Once you have completed all the activities in this job experience you can use the button
            below to submit it to your teacher.
          </p>
          <p class="mb-5">
            <u>Note:</u> Once you submit it, you will not be able to add to or edit it anymore.
          </p>

          <submit-experience-button-wrapper />
          <p class="mt-5">
            After submitting your experience, there are two other things you need to do:
          </p>
          <p class="mt-5">1. Complete your Reflection and Thank you Letter for this experience</p>
          <p class="mt-5">2. Request your certificate for this experience</p>
          <p class="mt-5">
            You <strong><u>MUST</u></strong> do (1) before (2) and you can access these using the
            links at the bottom of the left hand menu
          </p>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import SubmitExperienceButtonWrapper from '@/views/WorkExperiences/components/WorkExperience/SubmitExperienceButtonWrapper.vue';

export default {
  name: 'vs-tabs-link',
  components: { SubmitExperienceButtonWrapper },
  watch: {
    '$route.path': function () {
      const buttonEl = document.getElementById(`tab-link-${this.activeChildIndex}`);
      if (buttonEl) {
        setTimeout(() => {
          buttonEl.focus();
        }, 500);
      }
    },
  },
  data() {
    return {
      tab_value: this.$route.path,
    };
  },
  props: {
    tab_contents: {
      type: Array,
      required: true,
    },
    experience: {
      type: Object,
      required: true,
    },
  },
  computed: {
    activeTabContents() {
      return this.tab_contents.filter((tab_content) => !tab_content.hidden);
    },
    activeChildIndex() {
      return this.activeTabContents.findIndex(
        (tab_content) => tab_content.link === this.$route.path,
      );
    },
  },
  methods: {
    onChange(event) {
      if (this.$route.path !== event.target.value) {
        this.$router.push(event.target.value);
      }
    },
    navigate(dir = 'right') {
      const maxLength = this.activeTabContents.length - 1;

      let navigationIndex = '';
      if (dir === 'right') {
        navigationIndex = this.activeChildIndex < maxLength ? this.activeChildIndex + 1 : 0;
      } else if (dir === 'left') {
        navigationIndex = this.activeChildIndex !== 0 ? this.activeChildIndex - 1 : maxLength;
      }

      const link = this.activeTabContents[navigationIndex].link;
      this.$router.push({ path: link });
      const buttonEl = document.getElementById(`tab-link-${navigationIndex}`);
      if (buttonEl) {
        buttonEl.focus();
      }
    },
    updateActivity(activity) {
      this.$emit('update-activity', activity);
    },
    tabIndex(index, item_name) {
      return this.activeChildIndex === index ||
        (item_name === 'Activities' && this.$route.name === 'activity-student')
        ? 0
        : -1;
    },
  },
};
</script>
